import styled, { css } from 'styled-components';
import { color, radius, screen, shadow, spacing } from '../../../theme';

export const StyledSkillsContainer = styled.div`
  border: 1px solid ${color('midnight_200')};
  border-radius: ${radius('lg')};
  padding: ${spacing('lg')};
  box-shadow: ${shadow('md')};
`;

const variants: {
  [key: string]: { overflow: string; flexWrap: string; display: string };
} = {
  isMobileScroll: {
    overflow: 'auto',
    flexWrap: 'nowrap',
    display: 'flex'
  }
};

export const StyledSkillsList = styled.ul<{ variant?: string }>`
  margin: 0;
  padding: 0;
  list-style: none;

  @media (min-width: ${screen('md')}) {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  @media (max-width: ${screen('mdMax')}) {
    ${({ variant }) =>
      variant &&
      variants[variant] &&
      css`
        display: ${variants[variant].display};
        overflow: ${variants[variant].overflow};
        flex-wrap: ${variants[variant].flexWrap};
      `}
  }
`;
